<template>
  <div>
    <v-toolbar class="my-md-auto" elevation="0"  >
      <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
        <h1><v-icon large>mdi-file-document-edit-outline</v-icon>{{$t('qualitycheck.product.producttypefiles')}}</h1>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          color=""
          class="ml-sm-2"
          @click="resetForm"
        >
          {{ $t('global.reset')}}
        </v-btn>
        <v-btn
          :loading="isLoading"
          class="ml-sm-2"
          color="primary"
          @click="onSendProdFileForm"
        >
          {{ $t('global.submit')}}
        </v-btn>
      </div>
    </v-toolbar>

    <ProducttypefileForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProducttypefileForm from '../../components/producttypefile/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'Producttypefile';

const { mapFields } = createHelpers({
  getterType: 'producttypefile/getField',
  mutationType: 'producttypefile/updateField'
});

export default {
  name: 'ProducttypefileCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Loading,
    ProducttypefileForm
  },
  data() {
    return {
      item: {
         accessory : [],
         controlUnit : [],
         machine : [],
         materialSupply : [],
         softwareVersion : [],
         industrialComputer : [],
         operatingSystem : [],
         optionMachine : [],
         toolHead : [],
         materialProductVersion : [],
      }
    };
  },
  mounted() {
    this.item.accessory = this.accessoryParent;
    this.item.controlUnit = this.controlUnitParent;
    this.item.machine = this.machineParent;
    this.item.materialSupply = this.materialSupplyParent;
    this.item.softwareVersion = this.softwareVersionParent;
    this.item.industrialComputer = this.industrialComputerParent;
    this.item.operatingSystem = this.operatingSystemParent;
    this.item.optionMachine = this.optionMachineParent;
    this.item.toolHead = this.toolHeadParent;
    this.item.materialProductVersion = this.materialProductVersionParent;
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations']),
    accessoryParent() {
      if(this.$route.params.parent.includes("accessories")) {
        return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
      }
      return [];
    },
    controlUnitParent() {
      if(this.$route.params.parent.includes("control_unit")) {
        return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
      }
      return [];
    },
    machineParent() {
      if(this.$route.params.parent.includes("machines")) {
        return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
      }
      return [];
    },
    materialSupplyParent() {
      if(this.$route.params.parent.includes("material_supplies")) {
        return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
      }
      return [];
    },
    softwareVersionParent() {
      if(this.$route.params.parent.includes("software_versions")) {
        return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
      }
      return [];
    },
    industrialComputerParent() {
      if(this.$route.params.parent.includes("industrial_computers")) {
        return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
      }
      return [];
    },
    operatingSystemParent() {
      if(this.$route.params.parent.includes("operating_systems")) {
        return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
      }
      return [];
    },
    optionMachineParent() {
      if(this.$route.params.parent.includes("options")) {
        return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
      }
      return [];
    },
    toolHeadParent() {

      if(this.$route.params.parent.includes("tool_heads")) {
        return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
      }
      return [];
    },
    materialProductVersionParent() {

    if(this.$route.params.parent.includes("material_product_versions")) {
      return [{'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent}];
    }
    return [];
    },

  },
  methods: {
    ...mapActions('producttypefile', ['create', 'reset']),
    onSendProdFileForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    }
  },

};
</script>